const _p = {
    DeviceInfo: {}
};

export default (NativeModules) => {
    const { DeviceInformation } = NativeModules || { DeviceInformation: {} };
    _p.DeviceInfo = DeviceInformation;

    return {
        getModel
    };
};

function getModel() {
    return _p.DeviceInfo.MODEL;
}